import { render, staticRenderFns } from "./org-list1.vue?vue&type=template&id=8c885a3c&scoped=true"
import script from "./org-list1.vue?vue&type=script&lang=js"
export * from "./org-list1.vue?vue&type=script&lang=js"
import style0 from "./org-list1.vue?vue&type=style&index=0&id=8c885a3c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c885a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c885a3c')) {
      api.createRecord('8c885a3c', component.options)
    } else {
      api.reload('8c885a3c', component.options)
    }
    module.hot.accept("./org-list1.vue?vue&type=template&id=8c885a3c&scoped=true", function () {
      api.rerender('8c885a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule/form/org-list1.vue"
export default component.exports